import {
  set as mutableSet,
  toPath,
  isFunction,
  isError,
  isWeakMap,
  mergeDeep,
} from 'src/utils/lodash-alternatives';

export const mergeWith = (source1, source2, customizer) => {
  const cloned = mergeDeep({}, source1);
  return mergeDeep(cloned, source2, customizer);
};

const cloneByPath = (object, path) => {
  const arrayPath = toPath(path);
  const { length } = arrayPath;
  const lastIndex = length - 1;
  let index = -1;
  const result = Object.assign({}, Object(object));
  let nested = result;

  while (nested != null && ++index < length) {
    const key = arrayPath[index];
    const value = nested[key];

    if (
      value != null &&
      !(isFunction(value) || isError(value) || isWeakMap(value))
    ) {
      nested[key] = Object.assign(
        {},
        index === lastIndex ? value : Object(value)
      );
    }
    nested = nested[key];
  }
  return result;
};

export const set = (path, value, object) => {
  const cloned = cloneByPath(object, path);
  mutableSet(cloned, path, value);
  return cloned;
};
